import thunk from "redux-thunk";
import { configureStore } from '@reduxjs/toolkit';
import { gpsreducer } from '../reducers/gpsreducer';
import { authreducer } from "../reducers/authreducer";
import { tripreducer } from '../reducers/tripreducer';
import { chatreducer } from '../reducers/chatreducer';
import { usersreducer } from "../reducers/usersreducer";
import { promoreducer } from "../reducers/promoreducer";
import { plansreducer } from '../reducers/plansreducer';
import { panicreducer } from '../reducers/panicreducer';
import { paymentreducer } from '../reducers/paymentReducer';
import { bookingreducer } from "../reducers/bookingreducer";
import { carlistreducer } from '../reducers/carlistreducer';
import { bannersreducer } from '../reducers/bannersreducer';
import { locationreducer } from '../reducers/locationreducer';
import { settingsreducer } from '../reducers/settingsreducer';
import { tasklistreducer } from '../reducers/tasklistreducer';
import { estimatereducer } from "../reducers/estimatereducer";
import { cartypesreducer } from "../reducers/cartypesreducer";
import { withdrawreducer } from '../reducers/withdrawreducer';
import { languagereducer } from '../reducers/languagereducer';
import { addresslistreducer } from '../reducers/addressreducer';
import { bookingslistreducer } from "../reducers/bookingslistreducer";
import { cancelreasonreducer } from "../reducers/cancelreasonreducer";
import { notificationreducer } from "../reducers/notificationreducer";
import { driverearningreducer } from '../reducers/driverearningreducer';
import { earningreportsreducer } from '../reducers/earningreportsreducer';
import { admSavedAddressesReducer } from '../reducers/admSavedAddressesReducer';

const rootReducer = {
  auth: authreducer,
  plans: plansreducer,
  gpsdata: gpsreducer,
  chatdata: chatreducer,
  tripdata: tripreducer,
  usersdata: usersreducer,
  banners: bannersreducer,
  promodata: promoreducer,
  panicdata: panicreducer,
  taskdata: tasklistreducer,
  cartypes: cartypesreducer,
  carlistdata: carlistreducer,
  bookingdata: bookingreducer,
  withdrawdata: withdrawreducer,
  settingsdata: settingsreducer,
  locationdata: locationreducer,
  languagedata: languagereducer,
  estimatedata: estimatereducer,
  paymentmethods: paymentreducer,
  addressdata: addresslistreducer,
  bookinglistdata: bookingslistreducer,
  notificationdata: notificationreducer,
  cancelreasondata: cancelreasonreducer,
  driverearningdata: driverearningreducer,
  earningreportsdata: earningreportsreducer,
  admSavedAddresses: admSavedAddressesReducer,
};

export default configureStore({
  middleware: [thunk],
  reducer: rootReducer as any
});
